import React from "react";
import ReactDOM from "react-dom/client";
import GlobalContext from "./context";
import Routes from "./routes";
import "normalize.css";
import "./index.css";
import "react-toastify/dist/ReactToastify.css";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { env } from "./env";

const stripePromise = loadStripe(env.REACT_APP_STRIPE_PUBLIC_KEY);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <GlobalContext>
      <Elements stripe={stripePromise}>
        <Routes />
      </Elements>
    </GlobalContext>
  </React.StrictMode>
);
